import { Component, EventEmitter, inject, Output, TemplateRef } from '@angular/core';
import { FormArray, FormControl, FormGroup, Validators } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

import { SharedService } from '../../../../shared/services/shared.service';
import { FacturacionService } from '../../../../shared/services/facturacion.service';
import { Select2Option } from 'ng-select2-component';
import { catObjetoImp } from '../../../../shared/models';

@Component({
  selector: 'app-modal-agregar-concepto',
  standalone: false,
  templateUrl: './modal-agregar-concepto.component.html',
  styleUrl: './modal-agregar-concepto.component.scss'
})
export class ModalAgregarConceptoComponent {
  private modalService = inject(NgbModal);
  public formConceptos: FormGroup;
  public listaConceptos: FormArray = new FormArray([]);
  public customListCatClaveProductServ: Select2Option[] = [];
  public customListCatClaveUnidad: Select2Option[] = [];
  public importeTemporal: number | null = null;
  public catObjetoImp: catObjetoImp[];
  public haveImpuestos: boolean = false;
  @Output() public sendConceptos: EventEmitter<FormArray> = new EventEmitter<FormArray>();

  constructor(
   
      private facturacionService: FacturacionService,
    private sharedService: SharedService
  ) {
    this.catObjetoImp = [
      {
        key: '01',
        value: 'No objeto de impuesto.',
      },
      {
        key: '02',
        value: 'Sí objeto de impuesto.',
      },
      {
        key: '03',
        value: 'Sí objeto del impuesto y no obligado al desglose.',
      },
      {
        key: '04',
        value: 'Sí objeto del impuesto y no causa impuesto.',
      },
      {
        key: '05',
        value: 'Sí objeto del impuesto, IVA crédito PODEBI.',
      },
    ];

    this.initFormConceptos();
  }

  public initFormConceptos() : void {
    this.formConceptos = new FormGroup({
      cantidad: new FormControl(null, [Validators.required]),
      claveUnidad: new FormControl(null, [Validators.required]),
      unidad: new FormControl(),
      noIdentificacion: new FormControl(),
      descripcion: new FormControl(null, [ Validators.required ]),
      valorUnitario: new FormControl(null, [ Validators.required ]),
      importe: new FormControl(null, [ Validators.required ]),
      descuento: new FormControl(),
      claveProdServ: new FormControl(null, [ Validators.required ]),
      objetoImp: new FormControl(null, [ Validators.required ]),
      impuestos: new FormControl({
        traslados: [],
        retenciones: []
      })
    });
    this.haveImpuestos = false;
  }

  public open(content: TemplateRef<any>) : void {
    this.initFormConceptos();
		this.modalService.open(content, { centered: true, size: 'xl', backdrop: 'static' });
	}

  public searchProd(event: any): void {
    // Guardamos el valor de búsqueda actual
    const searchTerm = event.search;

    // Definimos una función auxiliar para realizar la búsqueda después del retraso
    if (searchTerm.length > 4) {
      while(this.customListCatClaveProductServ.length) {
        this.customListCatClaveProductServ.pop();
      }

      this.facturacionService
        .claveProductodes(searchTerm)
        .subscribe((response) => {
          this.customListCatClaveProductServ = response.map(item => ({
            label: `${item.c_ClaveProdServ} - ${item.Descripcion}`,
            value: item.c_ClaveProdServ
          }));
        });
    } else {
      // Si el término de búsqueda es corto, limpiamos el array de resultados
      while(this.customListCatClaveProductServ.length) {
        this.customListCatClaveProductServ.pop();
      }
    }
  }

  public searchClaveUnidad(event: any): void {
    // Guardamos el valor de búsqueda actual
    const searchTerm = event.search;
    // Definimos una función auxiliar para realizar la búsqueda después del retraso
    if (searchTerm.length > 3) {
      while (this.customListCatClaveUnidad.length) {
        this.customListCatClaveUnidad.pop();
      }
      this.facturacionService
        .catalogoClaveUnidadM(searchTerm)
        .subscribe((response) => {
          response.forEach((item) => {
            this.customListCatClaveUnidad.push({
              label: item.cClaveUnidad + ' - ' + item.nombre,
              value: item.cClaveUnidad,
            });
          });
        });
    } else {
      // Si el término de búsqueda es corto, limpiamos el array de resultados
      while (this.customListCatClaveUnidad.length) {
        this.customListCatClaveUnidad.pop();
      }
    }
  }

  public setClaveByClaveUnidad(): void {
    let claveSelected = this.customListCatClaveUnidad.filter(clave => clave.value === this.formConceptos.value['claveUnidad']);
    if (claveSelected) {
      let descripcionUnidad = claveSelected[0].label.split('-');
      this.formConceptos.controls['unidad'].setValue(descripcionUnidad[1].trim());
    }
  }

  public calcularImporte() : void {
    if (this.formConceptos.value['cantidad'] && this.formConceptos.value['valorUnitario']) {
      let importe = this.formConceptos.value['cantidad'] * this.formConceptos.value['valorUnitario'];
      this.formConceptos.controls['importe'].setValue(importe);
      if (this.formConceptos.value['descuento']) {
        if (this.formConceptos.value['descuento'] > importe) {
          this.formConceptos.controls['importe'].setValue(importe);
          this.formConceptos.controls['descuento'].setValue(null);
          this.sharedService.eventCreateToaster.emit({
            header: '¡Error!',
            message: 'El valor del descuento debe ser menor o igual al valor del importe',
            type: 'error',
            delay: 6000
          });
        } else {
          this.formConceptos.controls['importe'].setValue(importe - this.formConceptos.value['descuento']);
        }
      } else {
        this.formConceptos.controls['importe'].setValue(importe);
      }
    } else {
      this.formConceptos.controls['importe'].setValue(null);
      this.importeTemporal = null;
    }
  }

  public validateObjetoImp() : void {
    switch(this.formConceptos.value['objetoImp']) {
      case '02':
        this.haveImpuestos = true;
        this.formConceptos.controls['impuestos'].addValidators(Validators.required);
        this.formConceptos.controls['impuestos'].updateValueAndValidity();
      break;
      default:
        this.haveImpuestos = false;
        this.formConceptos.controls['impuestos'].removeValidators(Validators.required);
        this.formConceptos.controls['impuestos'].updateValueAndValidity();
      break;
    }
  }

  public setImpuestos(formImpuestos: any) : void {
    this.formConceptos.controls['impuestos'].setValue(formImpuestos);
  }

  public agregarConcepto() : void {
    let impuestos:any = this.formConceptos.value['impuestos'];
    
    if (this.formConceptos.valid) {
      if (this.formConceptos.value['objetoImp'] === '02') {
        if (impuestos.traslados.length >= 1 || impuestos.retenciones.length >= 1) {
        
          this.listaConceptos.push(this.formConceptos);
          this.sendConceptos.emit(this.listaConceptos);
          while(this.customListCatClaveProductServ.length) {
            this.customListCatClaveProductServ.pop();
          }
          this.modalService.dismissAll();
        } else {
          this.sharedService.eventCreateToaster.emit({
            header: '¡Error!',
            message: 'Añade a tu concepto por lo menos un impuesto para continuar.',
            type: 'error',
            delay: 6000
          });
        }
      } else {
        this.listaConceptos.push(this.formConceptos);
        this.sendConceptos.emit(this.listaConceptos);
        this.modalService.dismissAll();
      }

    } else {
      this.sharedService.eventCreateToaster.emit({
        header: '¡Error!',
        message: 'Completa los campos obligatorios para añadir tu concepto.',
        type: 'error',
        delay: 6000
      });
    }
  }
}
